import { SwapOutlined } from '@ant-design/icons';
import {
    Button,
    FormControl,
    InputLabel,
    MenuItem as MuiMenuItem,
    Select,
} from '@mui/material';
import ConfirmationModal from 'components/modal/ConfirmationModal';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const DEFAULT_STATUS_OPTIONS = ['PENDING', 'CONFIRMED', 'COMPLETED', 'CANCELLED'];

export const changeStatusAction = ({ service }) => {
    const entity = service.getModel();
    const statusOptions =
        entity?.ModelFeatureAttribute?.STATUS_OPTIONS || DEFAULT_STATUS_OPTIONS;

    return props => {
        const { component: MenuItem, onClick, params, ...restProps } = props;

        const { id, row } = params;
        const value = 'change_status';
        const label = 'Change Status';

        const { enqueueSnackbar } = useSnackbar();
        const [openModal, setOpenModal] = useState(false);
        const [selectedStatus, setSelectedStatus] = useState(
            row?.status || 'PENDING',
        );

        const handleChangeStatus = async () => {
            try {
                await service.updateStatus(id, selectedStatus);
                enqueueSnackbar('Status updated successfully', {
                    variant: 'success',
                });
                onClick(value);
                setOpenModal(false);
            } catch (err) {
                const msg =
                    err?.response?.data?.message || 'Failed to update status';
                enqueueSnackbar(msg, { variant: 'error' });
            }
        };

        return (
            <>
                <ConfirmationModal
                    onClose={() => setOpenModal(false)}
                    isOpen={openModal}
                    title="Change Status"
                    renderActions={() => (
                        <>
                            <Button
                                onClick={() => setOpenModal(false)}
                                variant="outlined"
                                color="secondary"
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={handleChangeStatus}
                                color="primary"
                                variant="contained"
                            >
                                Confirm
                            </Button>
                        </>
                    )}
                >
                    <FormControl fullWidth sx={{ mt: 1 }}>
                        <InputLabel id="status-select-label">
                            Status
                        </InputLabel>
                        <Select
                            labelId="status-select-label"
                            value={selectedStatus}
                            label="Status"
                            onChange={e => setSelectedStatus(e.target.value)}
                        >
                            {statusOptions.map(status => (
                                <MuiMenuItem key={status} value={status}>
                                    {status}
                                </MuiMenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </ConfirmationModal>
                <MenuItem
                    key={value}
                    value={value}
                    label={label}
                    icon={<SwapOutlined />}
                    onClick={() => setOpenModal(true)}
                    {...restProps}
                >
                    {label}
                </MenuItem>
            </>
        );
    };
};
